import lozad from 'lozad';

function initLozad() {
    const observer = lozad('.lozad', {
        rootMargin: '200px',
        load(el) {
            const { tagName } = el;
            if (tagName === 'IMG') {
                el.src = el.dataset.src;
                preloadImgsSlider($(el).closest('.slick-list'));
            }

            if (tagName === 'DIV') {
                let bg = el.getAttribute('data-bg-desktop');

                if (window.matchMedia('(max-width: 1023px)').matches) {
                    bg = el.getAttribute('data-bg-vertical-tablet');
                } else if (window.matchMedia('(max-width: 1399px)').matches) {
                    bg = el.getAttribute('data-bg-horizontal-tablet');
                }

                el.style.backgroundImage = `url(${bg})`;
            }
        },
    });

    observer.observe();
}

function preloadImgsSlider($slider) {
    if (!$slider.length) {
        return;
    }

    const imgs = $slider.find('img');
    for (let index = 0; index < imgs.length; index++) {
        const $img = $(imgs[index]);

        if (!$img.data('loaded')) {
            $img.attr('src', $img.data('src'));
            $img.attr('data-loaded', 'true');
        }
    }
}

initLozad();
window.initLozad = initLozad;



// WEBPACK FOOTER //
// ./js/main/module/lazyload/index.js